export default __webpack_public_path__ + "static/media/Dislike_Unselected.ae3ebf2e.svg";